const KILO = 1024;
const KILO_SIZES = ['байт', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб'];
export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) {
        return '';
    }
    const i = Math.floor(Math.log(bytes) / Math.log(KILO));
    return `${parseFloat((bytes / Math.pow(KILO, i)).toFixed(decimals))} ${KILO_SIZES[i]}`;
};
//# sourceMappingURL=formatBytes.js.map